import React, { useState, useEffect, useContext, useMemo } from "react";
import "./news.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import Pagination from "react-js-pagination";
import Cards from "../../common/card";
import Loading from "../../common/loading";
import Errors from "../../common/error";
import { TabTitle } from "../../common/dynamicTitle";
import Breadcrumbs from "../../common/breadcumb";
import { LangContext } from "../../context/LangContext";

function NewsAndUpdate() {
  const { state } = useContext(LangContext);
  const nep = state.np;
  const { slug } = useParams();
  const [allNews, setAllNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 6;

  const urlSlug = slug === "news-&-events" ? "news" : slug;
  let pageTitle;

  if (slug === "news-&-events") {
    pageTitle = nep ? "समाचार र घटनाहरू" : "News & Events";
  } else if (slug === "csr") {
    pageTitle = "CSR";
  } else {
    pageTitle = nep ? "समाचार" : "News";
  }

  TabTitle(`GMBF | ${pageTitle}`);
  const API_URL = `${process.env.REACT_APP_URL}${urlSlug}/all/`;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await axios.get(API_URL);
        setAllNews(nep ? response.data.items.np : response.data.items.en);
      } catch (err) {
        console.error("Error fetching news:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [urlSlug, nep]);

  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentNews = useMemo(() => {
    return allNews.slice(indexOfFirstItem, indexOfLastItem);
  }, [allNews, activePage]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  if (loading) return <Loading />;
  if (error) return <Errors />;

  return (
    <>
      <Breadcrumbs PageTitle={pageTitle} />

      <div className="InsidePageContainer">
        <div className="faq-box">
          <div className="wrapper">
            <ul className="cards">
              {currentNews.length === 0 ? (
                <p>No Content Found</p>
              ) : (
                currentNews.map((news) => (
                  <Cards key={news.id} card={news} url={`../${slug}/`} />
                ))
              )}
            </ul>
            {allNews.length > itemsPerPage && (
              <div className="parent-pagination">
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={itemsPerPage}
                  totalItemsCount={allNews.length}
                  pageRangeDisplayed={5}
                  firstPageText="«"
                  lastPageText="»"
                  itemClass="page-item"
                  linkClass="page-link"
                  onChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default NewsAndUpdate;
